import { render } from "./DeleteNotAllowed.vue?vue&type=template&id=140b8e82&scoped=true"
import script from "./DeleteNotAllowed.vue?vue&type=script&lang=js"
export * from "./DeleteNotAllowed.vue?vue&type=script&lang=js"

import "./DeleteNotAllowed.vue?vue&type=style&index=0&id=140b8e82&scoped=true&lang=css"

import exportComponent from "C:\\workspaces\\HGAccount\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140b8e82"]])

export default __exports__